
export const TopCategoriesChartConfig = (data = [], graphicText = "") => {

  const topFive = [...data].sort((a, b) => b.value - a.value).slice(0, 5);
  const total = topFive.reduce((acc, cur) => acc + cur.value, 0);

  const colors = ["#8B5CF6", "#10B981", "#F59E0B", "#3B82F6", "#EF4444"];
  const withPercent = topFive.map((item, i) => ({
    ...item,
    percent: ((item.value / total) * 100).toFixed(1),
    color: colors[i % colors.length]
  }));

  const option = {
    color: colors,
    tooltip: {
      trigger: "item",
      formatter: (params) => {
        return `${params.name}: ${params.value} (${params.percent}%)`;
      },
      backgroundColor: "#fff",
      borderColor: "#ddd",
      borderWidth: 1,
      textStyle: { color: "#111" }
    },
    series: [
      {
        name: "Top Categories",
        type: "pie",
        radius: ["60%", "80%"],
        center: ["50%", "45%"],
        label: { show: false },
        labelLine: { show: false },
        data: withPercent.map((i) => ({
          value: i.value,
          name: i.name,
          itemStyle: { color: i.color }
        }))
      }
    ],
    graphic: [
      {
        type: "text",
        left: "center",
        top: "40%",
        style: {
          text: total.toLocaleString(),
          fontSize: 22,
          fontWeight: 600,
          fill: "#111",
          textAlign: "center"
        }
      },
      {
        type: "text",
        left: "center",
        top: "53%",
        style: {
          text: graphicText || "",
          fontSize: 12,
          fill: "#10B981",
          textAlign: "center"
        }
      }
    ]
  };

  return { option, withPercent };
};
